import { Component, OnInit } from '@angular/core';
import {AlertController, ModalController, NavController, NavParams} from '@ionic/angular';
import * as globals from 'src/globals';
import {ClubList, createClubList} from 'src/data/club-course';
import {PlayerService} from 'src/providers/player-service/player-service';
import {Country} from 'src/data/country-location';
import { NavigationExtras, Router } from '@angular/router';
import { AddStateListPage } from '../add-state-list/add-state-list.page';
@Component({
  selector: 'app-add-location',
  templateUrl: './add-location.page.html',
  styleUrls: ['./add-location.page.scss'],
})
export class AddLocationPage implements OnInit {
  clubList: ClubList;
  openedModal: boolean = false;
  searchQuery: string;
  stateName: string;

  state: string;
  city: string;
  country: string = "MYS";
  countryList: Array<Country>;
  navigationExtras :NavigationExtras={};  
  dataExtras:any;
  constructor(
        private nav: NavController,
        private modalCtl: ModalController,
        private navParams: NavParams,
        private alertCtl: AlertController,
        private playerService: PlayerService,        
        private router: Router,

  ) {
    this.clubList    = createClubList();
    this.dataExtras = this.router.getCurrentNavigation().extras.state;
 
    this.openedModal=this.dataExtras.fromBookNow;
   }

  ngOnInit() {
    this.getCountry();
  }

  getCountry() {
    this.playerService.getCountryList()
            .subscribe((data: Array<Country>) => {
                        
                        this.countryList = data;
                        
    });

    
}

async goStatePicklist() {
  const modal:any = await this.modalCtl.create(
    {
      component:AddStateListPage,
      componentProps:{
        openedModal: true
      }
    });
  modal.present();
}

addFavouriteLocation() {

  // if (!isPresent(this.state)) {
  //     globals.displayError(this.alertCtl, "State cannot be blank!", "Favourite Location", "OK");
  
  //     return;
  // }

  this.playerService.addFavoriteLocation(this.country, this.state, this.city)
      .subscribe(() => {
          // this.events.publish("FavouriteListUpdate");
          // this.nav.pop();
          this.modalCtl.dismiss();

      })
}

close() {
  this.modalCtl.dismiss();
}


}
